export default {
  common: {
    logout: 'Déconnexion',
    help: 'Aide',
    docs: 'Documentation',
    retry: 'Réessayer',
    home: 'Accueil',
    cancel: 'Annuler',
    confirm: 'Confirmer',
    save: 'Enregistrer',
    delete: 'Supprimer',
    edit: 'Modifier',
    search: 'Rechercher',
    noResults: 'Aucun résultat',
    noData: 'Aucune donnée disponible',
    back: 'Retour',
    close: 'Fermer',
    clear: 'Effacer',
    rename: 'Renommer',
    continue: 'Continuer',
    later: 'Faire plus tard',
    previous: 'Précédent',
    next: 'Suivant',
    complete: 'Terminer',
    change: 'Modifier',
    or: 'ou',
    loading: 'Chargement...',
    loadingData: 'Chargement des données...',
    create: 'Créer',
    update: 'Mettre à jour',
    remove: 'Retirer',
    apply: 'Appliquer',
    active: 'Actif',
    inactive: 'Inactif',
    enabled: 'Activé',
    disabled: 'Désactivé',
    pending: 'En attente',
    viewAll: 'Voir tout',
    errorLoading: 'Erreur lors du chargement des données',
    errorLoadingData: 'Erreur lors du chargement des données',
    saveChanges: 'Enregistrer les modifications',
    changesSaved: 'Modifications enregistrées !',
    saveError: 'Échec de l\'enregistrement',
    by: 'par',
    download: 'Télécharger',
    insert: 'Insérer',
    yes: 'Oui',
    no: 'Non',
    language: 'Langue',
    theme: {
      title: 'Thème',
      light: 'Clair',
      lightTooltip: 'Utiliser le mode clair',
      dark: 'Sombre',
      darkTooltip: 'Utiliser le mode sombre',
      system: 'Système',
      systemTooltip: 'Suivre les préférences système',
    },
    faq: {
      title: 'FAQ',
      description: 'Trouvez les réponses aux questions fréquentes',
    },
    form: {
      unsavedChanges: 'Vous avez des modifications non enregistrées',
      save: 'Enregistrer',
      cancel: 'Annuler',
      saving: 'Enregistrement...',
      savedSuccessfully: 'Modifications enregistrées !',
      saveError: "Une erreur est survenue lors de l'enregistrement",
      dismiss: 'Fermer',
    },
  },
  dates: {
    today: "Aujourd'hui",
    yesterday: 'Hier',
    tomorrow: 'Demain',
    daysAgo: 'Il y a {days} jours',
    inDays: 'Dans {days} jours',
    weeksAgo: 'Il y a {weeks} semaines',
    inWeeks: 'Dans {weeks} semaines',
  },
  errors: {
    system: {
      title: 'Une erreur est survenue',
      message: "Une erreur inattendue s'est produite. Veuillez réessayer.",
      code: "Code d'erreur",
    },
    networkError: 'Erreur réseau. Veuillez vérifier votre connexion.',
    serverError: 'Erreur serveur. Veuillez réessayer plus tard.',
    unknownError: "Une erreur inconnue s'est produite",
    forbidden: "Vous n'avez pas les droits pour cette action.",
    rateLimited: 'Trop de demandes. Patientez un instant, puis réessayez.',
    conflict: 'Cet élément a changé entre-temps. Rechargez la page, puis réessayez.',
    validation: 'Une des valeurs saisies a été refusée. Vérifiez le formulaire, puis réessayez.',
    notFound: "Cet élément n'existe plus, ou n'est plus accessible.",
    tooLarge: 'Le contenu envoyé est trop volumineux.',
    unavailable: 'Le service est momentanément indisponible. Réessayez dans un instant.',
  },
  notFound: {
    title: 'Page non trouvée',
    description: "La page que vous recherchez n'existe pas ou a été déplacée.",
    backHome: "Retour à l'accueil",
  },
  undo: {
    action: 'Annuler',
  },
  share: {
    action: 'Partager…',
  },
  navigation: {
    main: 'Navigation principale',
    apps: 'Applications',
    more: 'Plus',
    moreActions: 'Plus d\'actions',
    moreWithTransfers: 'Plus, {count} transfert à suivre | Plus, {count} transferts à suivre',
    profile: 'Profil',
    credits: 'Crédits',
    creditsTooltip: 'Solde : {amount}',
    reloadCredits: 'Recharger les crédits',
    sectionPicker: '{title}, {section} : changer de section',
    sectionPickerPending: '{title}, {section} : changer de section, {count} à traiter | {title}, {section} : changer de section, {count} à traiter',
  },
  table: {
    sortBy: 'Trier par',
    sortChip: 'Tri : {column}',
    sortNone: 'Trier',
    order: 'Ordre',
    ascending: 'Croissant',
    descending: 'Décroissant',
    select: 'Sélectionner',
    clearSelection: 'Annuler la sélection',
    selected: '{count} sélectionné | {count} sélectionnés',
    selectAll: 'Tout sélectionner',
  },
  userDrawer: {
    settings: {
      title: 'Paramètres',
      inviteUsers: 'Inviter des utilisateurs',
      account: 'Paramètres du compte',
    },
    quickActions: 'Actions rapides',
    organizations: 'Organisations',
    foundingLimitReached: 'Maximum atteint sur cette plateforme ({limit})',
    foundingUnverified: 'Confirmez d’abord votre adresse e-mail',
    helpLink: 'Aide - Documentation',
  },
  pickers: {
    uploadNotServed: "Cet envoi n'est pas encore disponible",
    file: {
      clickOrDrag: 'Cliquez ou déposez des fichiers ici',
      defaultHelper: 'Max {size}Mo par fichier',
      maxFilesReached: 'Nombre maximum de fichiers atteint',
      uploadError: 'Échec du téléchargement',
      fileTooLarge: 'Le fichier dépasse la limite de {size}Mo',
      invalidFileType: 'Type de fichier non autorisé',
    },
    metadataFile: {
      clickOrDrag: 'Cliquez ou déposez un fichier ici',
      defaultHelper: 'Max {size}Mo',
      attachedFile: 'Fichier joint',
      view: 'Voir le fichier',
      uploading: 'Téléchargement...',
      replace: 'Remplacer',
      remove: 'Supprimer',
      fileTooLarge: 'Le fichier dépasse la limite de {size}Mo',
      invalidFileType: 'Type de fichier non autorisé',
      uploadFailed: 'Échec du téléchargement',
    },
    image: {
      uploading: 'Téléchargement...',
      replace: 'Remplacer',
      remove: 'Supprimer',
      uploadButton: 'Télécharger une image',
      formats: 'Formats : JPG/PNG/WebP - Max {size}Mo',
      fileTooLarge: "L'image dépasse la limite de {size}Mo",
      invalidFileType: 'Seules les images JPG, PNG et WebP sont autorisées',
      uploadFailed: 'Échec du téléchargement',
    },
    color: {
      noColor: 'Aucune couleur',
    },
    date: {
      selectDate: 'Sélectionner une date',
    },
    dateRange: {
      selectRange: 'Sélectionner une période',
      cancel: 'Annuler',
      apply: 'Appliquer',
      shortcuts: {
        today: "Aujourd'hui",
        yesterday: 'Hier',
        last7Days: '7 derniers jours',
        last30Days: '30 derniers jours',
        thisMonth: 'Ce mois-ci',
        lastMonth: 'Mois dernier',
        thisYear: 'Cette année',
        lastYear: 'Année dernière',
      },
    },
  },
  upload: {
    drawer: {
      title: 'Envois',
      clearCompleted: 'Effacer les terminés',
      empty: 'Aucun envoi',
      emptyHelper: 'Glissez des fichiers ici ou cliquez pour parcourir',
    },
    miniDock: {
      uploading: '{count} en cours | {count} en cours',
      pending: '{count} en attente | {count} en attente',
    },
    dropZone: {
      clickOrDrag: 'Cliquez ou glissez des fichiers ici',
      helper: 'Max {size}Mo par fichier',
      maxFilesReached: 'Nombre maximum de fichiers atteint',
    },
    item: {
      pending: 'En attente',
      uploading: 'Envoi en cours...',
      paused: 'En pause',
      completed: 'Terminé',
      failed: 'Échec',
      cancelled: 'Annulé',
    },
    actions: {
      pause: 'Pause',
      resume: 'Reprendre',
      cancel: 'Annuler',
      retry: 'Réessayer',
      remove: 'Supprimer',
    },
    errors: {
      fileTooLarge: 'Le fichier dépasse la limite de {size}Mo',
      tooManyFiles: 'Maximum {max} fichiers autorisés',
      uploadFailed: "Échec de l'envoi",
      networkError: 'Erreur réseau, nouvelle tentative',
    },
  },
  editor: {
    insertLink: 'Insérer un lien',
    editLink: 'Modifier le lien',
    linkUrl: 'URL du lien',
    insertImage: 'Insérer une image',
    imageUrl: "URL de l'image",
    browseLibrary: 'Parcourir la bibliothèque',
    dragOrClick: 'Glisser-déposer ou cliquer pour importer',
    uploading: 'Importation…',
    uploadFailed: "Échec de l'importation",
    insertTable: 'Insérer un tableau',
    addRow: 'Ajouter une ligne',
    addColumn: 'Ajouter une colonne',
    deleteTable: 'Supprimer le tableau',
  },
  imageViewer: {
    close: 'Fermer',
    download: 'Télécharger',
    zoomIn: 'Zoom avant',
    zoomOut: 'Zoom arrière',
    rotateLeft: 'Pivoter à gauche',
    rotateRight: 'Pivoter à droite',
    fullscreen: 'Plein écran',
    exitFullscreen: 'Quitter le plein écran',
    previous: 'Image précédente',
    next: 'Image suivante',
    loading: "Chargement de l'image...",
    error: "Échec du chargement de l'image",
    retry: 'Réessayer',
  },
  metadata: {
    linkLabel: 'Texte affiché',
    openFile: 'Ouvrir le fichier',
    noFile: 'Aucun fichier',
    requiredFieldsWarning: 'Certains champs obligatoires ne sont pas renseignés.',
    changed: 'Modifié',
    before: 'Avant :',
    emptyValue: '(vide)',
    revert: 'Rétablir',
    requiredFieldsBanner: '{count} champ(s) obligatoire(s) à compléter avant de sauvegarder.',
  },
  modals: {
    confirm: {
      title: "Confirmer l'action",
    },
    delete: {
      title: 'Supprimer',
      confirm: 'Supprimer',
      warning: 'Cette action est irréversible.',
    },
  },
  validation: {
    required: 'Ce champ est requis',
    invalidEmail: 'Adresse email invalide',
    invalidUrl: 'URL invalide',
  },
}
